import { HttpClient } from '@angular/common/http';
import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BaseSiteService } from '@spartacus/core';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { ExcelDownloadService } from 'src/app/shared/services/excel-download.service';
import { AccountOverviewService } from '../../account-overview.service';
import { UploadDetailsComponent } from '../upload-details/upload-details.component';

const EXCEL_TYPE =
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
const EXCEL_EXTENSION = '.xlsx';

@Component({
  selector: 'app-order-products',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './order-products.component.html',
  styleUrls: ['./order-products.component.scss'],
})
export class OrderProductsComponent implements OnInit, OnDestroy {
  files: any;
  uploadJsonData: any;
  baseSiteId: string;
  baseServiceSub: Subscription;
  accServiceSub: Subscription;

  constructor(
    private readonly modalService: NgbModal,
    public readonly excelService: ExcelDownloadService,
    public readonly accountService: AccountOverviewService,
    private readonly baseSiteService: BaseSiteService,
    private readonly http: HttpClient
  ) {}

  fileURL: string;

  ngOnInit(): void {
    this.baseSiteService
      .getActive()
      .pipe(take(1))
      .subscribe((res) => {
        this.baseSiteId = res;
        this.fileURL =
          this.baseSiteId == 'vax'
            ? '../../../../assets/docs/vax/VAXlistOrderTemplate.xlsx'
            : '../../../../assets/docs/vsh/VSHlistOrderTemplate.xlsx';
      });
  }
  ngOnDestroy(): void {
    this.baseServiceSub?.unsubscribe();
    this.accServiceSub?.unsubscribe();
  }
  orderUploadFile(event) {
    if (event.target.files[0].type === EXCEL_TYPE) {
      this.excelToJson(event.target.files[0]);
    }
  }

  uploadClick(event) {
    event.target.value = '';
  }

  onFileChange(pFileList: File[]) {
    this.files = Object.keys(pFileList).map((key) => pFileList[key]);
    if (this.files[0].type === EXCEL_TYPE) {
      this.excelToJson(this.files[0]);
    }
  }

  openUploadPopup() {
    const modalRef = this.modalService.open(UploadDetailsComponent, {
      backdrop: 'static',
      windowClass: `upload-modal ${this.baseSiteId}`,
    });
    modalRef.componentInstance.uploadDetails = this.uploadJsonData;
  }

  excelToJson(ev) {
    this.uploadJsonData = ev;
    this.openUploadPopup();
  }

  public downloadXls() {
    let data: any;
    this.accServiceSub = this.accountService
      .orderTemplateDownload(this.baseSiteId)
      .subscribe((res) => {
        data = res;
        data.forEach((element, index) => {
          if (index == 0)
            element.Customer = JSON.parse(localStorage.getItem('accountId'));
        });
        let name =
          this.baseSiteId == 'vax'
            ? 'VAXlistOrderTemplate'
            : 'VSHlistOrderTemplate';
        this.excelService.exportAsExcelFile(data, name, true);
      });
  }
}
